import i18n from 'utils/i18n';
import { DialogPlugin } from 'tdesign-react';
import { queryAuthorize, saveAuthorize } from 'apis';
import { VirtualmanType } from 'apis/interfaces/asset';
const { t } = i18n;
export const akskAuthConfirm = async (callback: Function, failCallback?: Function) => {
  try {
    const { authorize } = await queryAuthorize();
    if (authorize === 1) {
      callback();
      return;
    }
  } catch (e) {
    failCallback?.();
  }

  const warnDialog = DialogPlugin.confirm({
    header: t('用户确认授权'),
    confirmBtn: t('确认授权'),
    cancelBtn: t('取消'),
    theme: 'warning',
    body: t('需要授权aksk由平台代为操作知识引擎机器人'),
    onConfirm() {
      saveAuthorize({ authorize: 1 }).then(() => {
        callback();
        warnDialog.hide();
      });
    },
    onClose() {
      failCallback?.();
      warnDialog.hide();
    },
  });
};
export const isLite2DCloud = (typeTag: string, schemeSelection?: number): boolean => {
  return typeTag === VirtualmanType.small_sample_lite_2d && schemeSelection === 1;
};

export const supportClient = (value: string) => {
  const suportKeyList = [
    VirtualmanType.small_sample_2d,
    VirtualmanType.small_sample_general_2d,
    VirtualmanType.small_sample_photo_2d,
  ];
  return suportKeyList.includes(value as VirtualmanType);
};
